<template>
  <ux-form
    ref="form"
    :data="formData"
    width="600px"
    :colon="true"
    :rules="rules"
    label-width="70px"
    data-automation="modify"
  >
    <ux-form-item :label="$t('HT.rebind.mac')" prop="mac_array">
      <ux-input v-model="formData.mac_array"></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          mac_array: '' // 主机MAC
        };
      }
    }
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.modify()
    };
  },

  created() {
    this.formData.mac_array = this.formData.tags.macArray.join(',');
  }
};
</script>
